<template>
<div style="margin-left: 4px">
  <h4>{{eitem.header | htmlToText}}</h4>
    <v-flex layout v-if="item">
      <v-text-field @focus="onFocus(eitem)" :error-messages="errorObj[eitem.name]" :label="eitem.itemHeader.quantity" v-model="item[eitem.value.quantity]"></v-text-field>
      <v-select :label="eitem.itemHeader.unit" :items="eitem.units" v-model="item[eitem.value.unit]"></v-select>
    </v-flex>  
  </div>
</template>

<script>
import utils from '../helpers/utils'
import { sync } from 'vuex-pathify'
export default {
  props: ['eitem', 'item', 'onFocus', 'save'],
  computed: {
    errorObj: sync('dialogErrors'),
  },
  filters: {
    htmlToText(val) {
      return val.replace('<br>', ' ')
    }
  },
  methods: {
  }
}
</script>